<template>
<div :class="mainClass" @click="onClick">
</div>
</template>

<script>
  import { EventBus } from '../EventBus.js'
  
  export default {
    mounted () {
      EventBus.$on('game-clicked', dat => {
        this.visible = true
        this.currentGame = dat['game']
      })
    },
    computed: {
      mainClass () {
        return 'overlay' + (this.visible ? ' visible' : '')
      }
    },
    methods: {
      onClick () {
        // EventBus.$emit('game-unclicked', { game: this.game, left: rect.right > width / 2 })
        EventBus.$emit('game-unclicked', { game: this.currentGame })
        this.visible = false
        this.currentGame = null
      }
    },
    data () {
      return {
        visible: false,
        currentGame: null
      }
    }
  }
</script>

<style>
.overlay {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    background-color: rgba(0, 0, 0, 0);
    z-index: -1;
    transition: all 100ms ease-in-out;
}
.overlay.visible {
    z-index: 8888;
    background-color: rgba(0, 0, 0, 0.75);
}
</style>


// WEBPACK FOOTER //
// src/components/Overlay.vue